import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationUpdateVariationArgs, BackendVariation } from 'src/types/backend';

import { VARIATION_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation UpdateVariation(
    $id: ID!
    $assetType: String!
    $copyText: String
    $copyTextMarkup: JSON
    $forceScoring: Boolean
    $scoringMethod: ScoringMethodInput
    $skipLock: Boolean
  ) {
    updateVariation(
      id: $id
      assetType: $assetType
      copyText: $copyText
      copyTextMarkup: $copyTextMarkup
      forceScoring: $forceScoring
      scoringMethod: $scoringMethod
      skipLock: $skipLock
    ) {
      ...Variation
    }
  }
  ${VARIATION_FRAGMENT}
`;

type Variables = Omit<BackendMutationUpdateVariationArgs, 'forceScoring'>;
type Result = BackendVariation;

export const updateVariation = async (
  { id, assetType, copyText, copyTextMarkup, scoringMethod, skipLock }: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      id,
      assetType,
      copyText,
      copyTextMarkup,
      scoringMethod,
      forceScoring: true,
      skipLock,
    },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
